import React from "react";
import { getTutuUrl } from "../utils/navigationUtils";
import { Button } from "./Button";
import creditIcon from "../assets/icons/credit-icon.svg";
import creditCheckIcon from "../assets/icons/credit-check-icon.svg";
import fcaRegulatedIcon from "../assets/icons/fca-regulated-icon.svg";
import tutuLogo from "../assets/tutu-logo.svg";

interface GuarantorLoanTileProps {
  innerRef?: React.Ref<HTMLDivElement>;
  className?: string;
}

/**
 * Guarantor loan tile shown on the customer home page alongside the
 * "Other credit options" tile. Sends the customer to Tutu (tutu.co.uk).
 */
const GuarantorLoanTile: React.FC<GuarantorLoanTileProps> = ({
  innerRef,
  className = "",
}) => {
  const handleApplyNow = () => {
    window.open(getTutuUrl("acc_dashboard"), "_blank", "noopener,noreferrer");
  };

  return (
    <div ref={innerRef} className={`mb-6 ${className}`}>
      <div className="flex mb-3">
        <img alt="credit icon" src={creditIcon} />
        <h2 className="text-2xl ml-2.5">GUARANTOR LOAN</h2>
      </div>
      <div className="container-white-rounded">
        <p className="mt-2">
          With Tutu you could borrow between £1,000 to £10,000 with help from
          a guarantor.
        </p>
        <p className="mt-2">
          A guarantor is normally a close family member or friend who agrees
          to repay the loan if you can’t.
        </p>
        <p className="mt-2">
          Limited credit and bad credit profiles are considered.
        </p>

        <ul className="mt-4 flex flex-col gap-3">
          <li className="flex items-center gap-4">
            <img
              alt=""
              src={creditCheckIcon}
              className="w-[22px] h-[22px] flex-shrink-0"
            />
            <span>
              Applying won’t affect your credit file, unless you take out a
              loan.
            </span>
          </li>
          <li className="flex items-center gap-4">
            <img
              alt=""
              src={fcaRegulatedIcon}
              className="w-[22px] h-[22px] flex-shrink-0"
            />
            <span>Authorised and Regulated by the Financial Conduct Authority</span>
          </li>
        </ul>

        <div className="mt-4 flex justify-center">
          <img alt="Tutu logo" src={tutuLogo} className="h-7" />
        </div>

        <hr className="my-4 border-black/10" />

        <div className="flex justify-center">
          <Button text="Apply now" onClick={handleApplyNow} />
        </div>
        <p className="text-center font-bold mt-2">Representative 49.9%APR</p>
        <p className="text-center">
          Failure to repay can impact yours and your guarantor’s credit file
        </p>
      </div>
    </div>
  );
};

export default GuarantorLoanTile;
